import { BaseModel } from "sjs-base-model";

// InfluencersCampaignsShardsModel
export default class InfluencersCampaignsShardsModel extends BaseModel {
    // response getting from the api mentioned end point
    failed = 0;
    skipped = 0;
    successful = 1;
    total = 1;
    constructor(data1) {
        super();
        this.update(data1);
    }
}
